import { createConfirmation } from "react-confirm";
import BuyerDetailDialog from "./BuyerDetailDialog";

export const showBuyerDetailDialog = createConfirmation(BuyerDetailDialog);
